import { Dimensions, ImageStyle, StyleSheet, TextStyle, ViewStyle } from 'react-native';

const isNotUndefind = (val) => typeof val !== 'undefined';

export function padding(top, right?, bottom?, left?) {
    return {
        paddingTop: top,
        paddingRight: isNotUndefind(right) ? right : top,
        paddingBottom: isNotUndefind(bottom) ? bottom : top,
        paddingLeft: isNotUndefind(left) ? left : isNotUndefind(right) ? right : top,
    };
}

export function margin(top, right?, bottom?, left?) {
    return {
        marginTop: top,
        marginRight: isNotUndefind(right) ? right : top,
        marginBottom: isNotUndefind(bottom) ? bottom : top,
        marginLeft: isNotUndefind(left) ? left : isNotUndefind(right) ? right : top,
    };
}

export function borderRadius(top, right?, bottom?, left?) {
    return {
        borderTopLeftRadius: top,
        borderTopRightRadius: isNotUndefind(right) ? right : top,
        borderBottomRightRadius: isNotUndefind(bottom) ? bottom : top,
        borderBottomLeftRadius: isNotUndefind(left) ? left : isNotUndefind(right) ? right : top,
    };
}

/**
 * @deprecated 半屏拖全凭容器vh不对
 */
export function vh(percentage) {
    const viewportHeight = Dimensions.get('window').height;
    const decimal = percentage * 0.01;
    let _percentage = parseInt(percentage, 10);

    // Hard limits
    if (_percentage < 0) {
        _percentage = 100;
    }
    if (_percentage > 1000) {
        _percentage = 1000;
    }

    return Math.round(viewportHeight * decimal);
}

export function vw(percentage) {
    const viewportWidth = Dimensions.get('window').width;
    const decimal = percentage * 0.01;
    let _percentage = parseInt(percentage, 10);

    // Hard limits
    if (_percentage < 0) {
        _percentage = 100;
    }
    if (_percentage > 1000) {
        _percentage = 1000;
    }

    return Math.round(viewportWidth * decimal);
}

export function styles<T extends Partial<ViewStyle | TextStyle | ImageStyle>>(styleRules: T) {
    const st = StyleSheet.create({
        default: styleRules,
    });
    return st.default as T;
}

const { width, height } = Dimensions.get('window');

/**
 * 宽度414px 设计稿下缩放
 */
const BaseW = 414;
export function scaleW(num: number) {
    return (width * num) / BaseW;
}

/**
 * 高度 874px 设计稿下缩放
 */
const BaseH = 874;
export function scaleH(num: number) {
    return (height * num) / BaseH;
}

export const styleGlobal = StyleSheet.create({
    primaryColor: {
        color: '#FF4906',
    },
    color999: {
        color: '#999',
    },
});
